import React from 'react';
import { Helmet } from 'react-helmet';
import Api from "../../../assets/js/utils/Api.js";
import axios from "axios";
import PropTypes from "prop-types";
import Auth from "../../../assets/js/utils/Auth.js";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Link from '@material-ui/core/Link';
import withStyles from "@material-ui/core/styles/withStyles";
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import LoaderComponent from '../../components/Loader'

const AgreementPolicy = class extends React.Component {
    constructor(props){
        super(props);

        this.store = this.props.store;
        this.history = this.props.history;
        const { user } = this.store.getState();
        let values = Api.prepareMemberObject(user);
        this.state = {
            values: values,
            showError: false,
            errorMessage: "",
            saving: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount(){
        const { authorized, user } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
        }    

        if(authorized && user.agreement_login === 0){
            this.updateLoginStatus();
        }
    }
    updateLoginStatus(){
        const values = {
            'agreement_login': 1
        }
        const source = axios.CancelToken.source();
        Api.updateLoginStatus(values, source).then((data) => {
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.user));
            let newUser = Api.prepareMemberObject(data.user);
            this.store.dispatch({type: 'UPDATE_STATE',state: {user: newUser}});
        }).catch(err => {
            this.setState({
                savingInfo: false, 
                showError: true, 
                errorMessage: err.message
            });
        });
    }
    handleCheckbox(e, name){
        this.setState({
            values: {
                ...this.state.values, 
                [name]:  e.target.checked ? 1 : 0
            }
        },() => {
            this.handleSubmit();
        });
    }
    handleSubmit(){
        const { user } = this.store.getState();
        let values = Object.assign({}, this.state.values);
        values.skipValidation = 1;

        this.setState({
            saving: true,
        })

        const source = axios.CancelToken.source();
        Api.updateUser(user.id, values, source).then((data) => {
            localStorage.setItem("sendlinx_userinfo", JSON.stringify(data.user));
            let newUser = Api.prepareMemberObject(data.user);
            this.store.dispatch({type: 'UPDATE_STATE',state: {user: newUser}});
        }).catch(err => {
            this.setState({
                showError: true, 
                errorMessage: err.message,
                saving: false
            });
        });
    }
    render() {
        const { classes } = this.props;
        const { values, saving } = this.state;
        const { authorized } = this.store.getState();
        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        return (
            <div className={classes.main}>
                <div className={classes.container}>
                    <div className={classes.content}>
                        <GridItem>
                            <div className={classes.privacyContainer+" "+classes.agreementContainer}>
                                <h3 className={classes.title}>Acceptable Use Policy</h3>
                                <div className="privacy-section">
                                    <p>Welcome to Sendlinx — a secure file and folder sharing platform. Before proceeding, all users must acknowledge and agree to the following:</p>
                                    <h4>No Spam Policy</h4>
                                    <p>You agree <span>not to use Sendlinx to send unsolicited, bulk, or spam communications</span> of any kind. Any abuse of this platform for spamming purposes is strictly prohibited and may result in immediate suspension or termination of your account.</p>
                                    <h4>Prohibited Content</h4>
                                    <p>At Sendlinx, we are dedicated to providing a secure and reliable file-sharing service for all users. To ensure the safety and integrity of our platform, we have established guidelines regarding prohibited content. By using Sendlinx, you agree to refrain from uploading, sharing, or distributing any content that violates the following:</p>
                                    <ul>
                                        <li><p><span>Illegal Content:</span> Any files that promote, facilitate, or contain illegal activities, including but not limited to software piracy, fraud, or trafficking of illegal substances.</p></li>
                                        <li><p><span>Harmful or Malicious Files:</span> Files that contain malware, viruses, ransomware, or other harmful code intended to damage or disrupt systems, devices, or networks.</p></li>
                                        <li><p><span>Violent or Explicit Material:</span> Files that include sexually explicit, graphic violence, or any content that promotes harm or abuse to individuals or groups.</p></li>
                                        <li><p><span>Hate Speech and Discrimination:</span> Files containing content that promotes hate, violence, or discrimination based on race, religion, gender, sexual orientation, nationality, or other protected characteristics.</p></li>
                                        <li><p><span>Harassment and Threats:</span> Any files that are intended to harass, intimidate, or harm others through direct threats or bullying.</p></li>
                                        <li><p><span>Privacy Violations:</span> Files that infringe on privacy rights, including the unauthorized sharing of personal or confidential information without consent.</p></li>
                                    </ul>
                                    <h4>Legitimate Use Only</h4>
                                    <p>Sendlinx is intended solely for <span>personal and professional use</span> that complies with all applicable laws and regulations. The platform is designed to support legitimate business, educational, and creative activities.</p>
                                    <h4>Positive Engagement</h4>
                                    <p>You agree to use this platform to <span>present content and opportunities in a responsible, respectful, and positive manner</span> that benefits and respects our customer base and community.</p>
                                    <p>For a more comprehensive explanation of the Terms of use, please visit: <Link href="https://sendlinx.com/terms-of-use/" target="_blank">https://sendlinx.com/terms-of-use</Link></p>
                                    <p>Sendlinx reserves the right to monitor and remove content that violates these terms. Repeated violations may result in account suspension or termination. Please use Sendlinx responsibly to help maintain a safe and positive experience for all users.</p>
                                    <div className='agree-content'>
                                        {
                                            saving ?
                                                <LoaderComponent color="custom" />
                                            : values.agreement_policy ?
                                                <p className='bold'>You agreed to the agreement policy on {values.agreement_policy_date}</p>
                                            :   
                                                <>
                                                    <p>By clicking <span>“I Agree”</span>, you confirm that you understand and accept the above terms and that you will use Sendlinx in accordance with these guidelines.</p>
                                                    <FormControlLabel
                                                        classes={{label: classes.label}}
                                                        control={
                                                            <Checkbox                                                
                                                                tabIndex={-1}
                                                                onClick={(e) => this.handleCheckbox(e, "agreement_policy")}
                                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                                icon={<Check className={classes.uncheckedIcon} />}
                                                                classes={{checked: classes.checked, root: classes.checkRoot}}
                                                                checked={(values.agreement_policy ? true : false)}
                                                                value="agreement_policy"
                                                            />
                                                        }
                                                        label="I have read and agree to the Acceptable Use Policy"
                                                    />
                                                </>
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                        </GridItem>
                    </div>
                </div>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
            </div>
        )
    }
}

AgreementPolicy.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(AgreementPolicy);
